import {
  Component,
  ViewEncapsulation,
  OnInit,
  OnDestroy,
  Input,
  computed,
  Renderer2,
} from "@angular/core";
import { CardModule } from "primeng/card";
import { TableModule } from "primeng/table";
import { UserManagementService } from "../../core/services/user-management.service";
import { GenericResponseDto } from "../../core/models/generic-response.dto";
import { ValidateLogin } from "../../core/models/validate-login.dto";
import { CommonModule } from "@angular/common";
import { HeaderService } from "../../core/services/header.service";
import { DashboardService } from "../../core/services/dashboard.service";
import { JniToastrService } from "../../core/services/jni-toastr.service";
import { QR2Reports } from "../../core/models/dashboard/qr2Reports";
import { QR3ReportsResponse } from "../../core/models/dashboard/qr3ReportsResponse";
import { Dashboard } from "../../core/models/dashboard/dashboard";
import { DashboardSession } from "../../core/models/dashboard/dashboard-session";
import { DashboardSetting } from "../../core/models/dashboard/dashboardSetting";
import { QR2ReportsDto } from "../../core/models/dashboard/qr2ReportsDto";
import { TableColumns } from "../../core/models/dashboard/tableColumns";
import { DashboardReport } from "../../shared/enums/dashboardReports";
import { CustomerAgingDetailReport } from "../../core/models/reports/customerAgingDetailReport";
import { columns as customerAgingColumns } from "../../shared/constants/tables/columns-information/customer-aging";
import { columns as arAgingColumns } from "../../shared/constants/tables/columns-information/ar-aging";
import { columns as ordersWrittenThisMonthColumns } from "../../shared/constants/tables/columns-information/orders-written-this-month";
import { columns as ordersInvoicedColumns } from "../../shared/constants/tables/columns-information/orders-invoiced";
import { columns as openOrdersByInHandsDateColumns } from "../../shared/constants/tables/columns-information/open-orders-by-inhands-date";
import { columns as readyToBillReportColumns } from "../../shared/constants/tables/columns-information/ready-to-bill-report";
import {
  completeListLink as customerAgingCompleteListLink,
  heading as customerAgingheading,
} from "../../shared/constants/tables/table-information/customer-aging";
import {
  completeListLink as arAgingCompleteListLink,
  heading as arAgingheading,
} from "../../shared/constants/tables/table-information/ar-aging";
import {
  completeListLink as ordersWrittenThisMonthCompleteListLink,
  heading as ordersWrittenThisMonthHeading,
} from "../../shared/constants/tables/table-information/customer-written-this-month";
import {
  completeListLink as ordersInvoicedCompleteListLink,
  heading as ordersInvoicedHeading,
} from "../../shared/constants/tables/table-information/orders-invoiced";
import {
  completeListLink as openOrdersByInHandsDateCompleteListLink,
  heading as openOrdersByInHandsDateHeading,
} from "../../shared/constants/tables/table-information/open-orders-by-inhands-date";
import {
  completeListLink as readyToBillReportCompleteListLink,
  heading as readyToBillReportHeading,
} from "../../shared/constants/tables/table-information/ready-to-bill-report";
import { ReadyToBillDto } from "../../core/models/reports/readyToBillDto";
import { OrderBillingStatus } from "../../core/models/dashboard/orderBillingStatus";
import { QR1ReportsDto } from "../../core/models/dashboard/qr1ReportsDto";
import { DashboardTablesComponent } from "./components/dashboard-tables/dashboard-tables.component";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { LoaderService } from "../../core/services/loader.service";
import { SharedService } from "../../core/services/shared.service";
import { AccountInfo } from "@azure/msal-browser";
import { OrdersWrittenReportDetailResponse } from "../../core/models/reports/ordersWrittenReportDetailResponse";
import { OrdersInvoicedDetailsResponse } from "../../core/models/reports/ordersInvoicedDetailsResponse";
import { Qr1CompleteComponent } from "./components/qr1-complete/qr1-complete.component";
import { ModalStackerComponent } from "../../shared/components/modal-stacker/modal-stacker.component";
import { ArAgingDetailsReportComponent } from "../reports/components/ar-aging-details-report/ar-aging-details-report.component";
import { Qr2CompleteComponent } from "./components/qr2-complete/qr2-complete.component";
import { Qr3CompleteComponent } from "./components/qr3-complete/qr3-complete.component";
import { Qr4CompleteComponent } from "./components/qr4-complete/qr4-complete.component";
import { ReadyToBillComponent } from "../reports/components/ready-to-bill/ready-to-bill.component";
import { OrderSummaryComponent } from "../orders/components/order-summary/order-summary.component";
import { ClientDetailsComponent } from "../clients/components/client-details/client-details.component";
import { SamplepoListingComponent } from "../samplePo/components/samplepo-listing/samplepo-listing.component";
@UntilDestroy()
@Component({
  selector: "jni-dashboard",
  imports: [
    CardModule,
    TableModule,
    CommonModule,
    DashboardTablesComponent,
    Qr1CompleteComponent,
    ModalStackerComponent,
    ArAgingDetailsReportComponent,
    Qr2CompleteComponent,
    Qr3CompleteComponent,
    Qr4CompleteComponent,
    ReadyToBillComponent,
    OrderSummaryComponent,
    ClientDetailsComponent,
    SamplepoListingComponent,
  ],
  templateUrl: "./dashboard.component.html",
  styleUrl: "./dashboard.component.scss",
  encapsulation: ViewEncapsulation.None,
})
export class DashboardComponent implements OnInit, OnDestroy {
  scrollHeight = "";
  headerHeight = computed(() => this.headerService.headerHeightSource$());
  validateLoginRes!: ValidateLogin;
  qr1DisplayModal = false;
  qr2DisplayModal = false;
  qr3DisplayModal = false;
  qr4DisplayModal = false;
  qr5DisplayModal = false;
  qr6DisplayModal = false;
  orderDisplayModal = false;
  saleOrderId = "";
  clientDisplayModal = false;
  clientId = "";
  samplePODisplayModal = false;
  ponumber = "";

  constructor(
    private headerService: HeaderService,
    private _userManagement: UserManagementService,
    private _dashboardService: DashboardService,
    private _loaderService: LoaderService,
    private _toastr: JniToastrService,
    private _sharedService: SharedService,
    private renderer: Renderer2
  ) {}

  isSidebarCollapsed = false;

  validateLogin(): void {
    this._userManagement.validateLogin().subscribe({
      next: (res: GenericResponseDto<ValidateLogin>) => {
        this.validateLoginRes = res.data;
      },
      error: err => {
        //this.showLoader = false;
        console.error("jniportal-validateLogin", err);
      },
    });
  }

  onCollapseChange(collapseState: boolean) {
    this.isSidebarCollapsed = collapseState; // Update parent state
  }

  ngOnInit() {
    setTimeout(() => {
      this.calculateScrollHeight();
      window.addEventListener("resize", this.calculateScrollHeight);
    }, 800);
    this.clearAndSetSimpleOrderSearchResponseObj();
    this._sharedService.setOrderSearchValue("");
    this._sharedService.setOrderSearchPlaceholderValue("Search");
    //this.user = this._authService.instance.getAllAccounts()[0];
    this.getUserSetting();
    //this.getUnprotectedCustomersCount();
    //this.getPendingCharges();
    this.getJNIDeletedRecordsQueueTrigger();
    //this.getInvoiceProposalsCount();
    //this.getCDICount();
    this.getArAgingFullData();
    //this.getDisputedInvoiceCount();
  }

  ngOnDestroy() {
    window.removeEventListener("resize", this.calculateScrollHeight);
  }

  calculateScrollHeight = () => {
    const windowHeight = window.innerHeight;

    const headerHeightExtra = this.headerHeight() + 220;
    const adjustedHeight = (windowHeight - headerHeightExtra) / 2;
    this.scrollHeight = `${adjustedHeight}px`;
  };

  public cardClass = ["order", "ledger", "invoice"];

  @Input() gridTitle = "";

  //clientTableData: VerifyClientList[] = [];
  //filterClientListData: { Account: string, Name: string, AvailableCredit: number, Address: string}[] | undefined;
  //filterVendorListData: GetAllVendorsDto[] | undefined;

  //leadListTableData: any[] = [];
  //orderTableData: any[] = [];
  //vendorTableTata: GetAllVendorsDto[] = [];
  //userTileTata: any[] = [];
  public user: AccountInfo[] | undefined;
  quadreport1 = "";
  quadreport2 = "";
  quadreport3 = "";
  quadreport4 = "";
  expiringDaysCount = 0;
  cdiCount = 0;
  invoicePreviewCount = 0;
  chargebackCount = 0;
  totalOutstanding = 0;
  disputedInvoicesCount = 0;
  qR2Reports: QR2Reports = {} as QR2Reports;
  qr2List: QR2ReportsDto[] = [];
  qr3Response: QR3ReportsResponse = {} as QR3ReportsResponse;

  qr1ReportsSmallLoader = false;
  qr2ReportsSmallLoader = false;
  qr3ReportsSmallLoader = false;
  qr4ReportsSmallLoader = false;

  customerAgingColumns: TableColumns[] = customerAgingColumns;
  customerAgingheading = customerAgingheading;
  customerAgingCompleteListLink = customerAgingCompleteListLink;

  arAgingColumns: TableColumns[] = arAgingColumns;
  arAgingheading = arAgingheading;
  arAgingCompleteListLink = arAgingCompleteListLink;

  ordersWrittenThisMonthColumns: TableColumns[] = ordersWrittenThisMonthColumns;
  ordersWrittenThisMonthHeading = ordersWrittenThisMonthHeading;
  ordersWrittenThisMonthCompleteListLink =
    ordersWrittenThisMonthCompleteListLink;

  readyToBillReportColumns: TableColumns[] = readyToBillReportColumns;
  readyToBillReportHeading = readyToBillReportHeading;
  readyToBillCompleteLinkList = readyToBillReportCompleteListLink;

  ordersInvoicedColumns: TableColumns[] = ordersInvoicedColumns;
  ordersInvoicedHeading = ordersInvoicedHeading;
  ordersInvoicedCompleteListLink = ordersInvoicedCompleteListLink;

  openOrdersByInHandsDateColumns: TableColumns[] =
    openOrdersByInHandsDateColumns;
  openOrdersByInHandsDateHeading = openOrdersByInHandsDateHeading;
  openOrdersByInHandsDateCompleteListLink =
    openOrdersByInHandsDateCompleteListLink;
  /* eslint-disable @typescript-eslint/no-explicit-any */
  qr1 = { showSmallLoader: true } as Dashboard<any>;
  qr2 = { showSmallLoader: true } as Dashboard<any>;
  qr3 = { showSmallLoader: true } as Dashboard<any>;
  qr4 = { showSmallLoader: true } as Dashboard<any>;
  /* eslint-enable @typescript-eslint/no-explicit-any */
  isQr1YearOverYearDashboardReport = false;
  isQr2YearOverYearDashboardReport = false;
  isQr3YearOverYearDashboardReport = false;
  isQr4YearOverYearDashboardReport = false;
  cachedData = [
    {
      type: DashboardReport.CustomerAging,
      data:
        (
          JSON.parse(
            sessionStorage.getItem(DashboardReport.CustomerAging) ?? "{}"
          ) as DashboardSession<QR1ReportsDto[]>
        ).data ?? [],
      userName:
        (
          JSON.parse(
            sessionStorage.getItem(DashboardReport.CustomerAging) ?? "{}"
          ) as DashboardSession<QR1ReportsDto[]>
        ).userName ?? "",
    },
    {
      type: DashboardReport.ReadyToBillReport,
      data:
        (
          JSON.parse(
            sessionStorage.getItem(DashboardReport.ReadyToBillReport) ?? "{}"
          ) as DashboardSession<ReadyToBillDto[]>
        ).data ?? [],
      userName:
        (
          JSON.parse(
            sessionStorage.getItem(DashboardReport.ReadyToBillReport) ?? "{}"
          ) as DashboardSession<ReadyToBillDto[]>
        ).userName ?? "",
    },
    {
      type: DashboardReport.ArAging,
      data:
        (
          JSON.parse(
            sessionStorage.getItem(DashboardReport.ArAging) ?? "{}"
          ) as DashboardSession<CustomerAgingDetailReport[]>
        ).data ?? [],
      userName:
        (
          JSON.parse(
            sessionStorage.getItem(DashboardReport.ArAging) ?? "{}"
          ) as DashboardSession<CustomerAgingDetailReport[]>
        ).userName ?? "",
    },
    {
      type: DashboardReport.OrdersWrittenthismonth,
      data:
        (
          JSON.parse(
            sessionStorage.getItem(DashboardReport.OrdersWrittenthismonth) ??
              "{}"
          ) as DashboardSession<OrdersWrittenReportDetailResponse[]>
        ).data ?? [],
      userName:
        (
          JSON.parse(
            sessionStorage.getItem(DashboardReport.OrdersWrittenthismonth) ??
              "{}"
          ) as DashboardSession<OrdersWrittenReportDetailResponse[]>
        ).userName ?? "",
    },
    {
      type: DashboardReport.OrdersBilledInvoiced,
      data:
        (
          JSON.parse(
            sessionStorage.getItem(DashboardReport.OrdersBilledInvoiced) ?? "{}"
          ) as DashboardSession<OrdersInvoicedDetailsResponse[]>
        ).data ?? {},
      userName:
        (
          JSON.parse(
            sessionStorage.getItem(DashboardReport.OrdersBilledInvoiced) ?? "{}"
          ) as DashboardSession<OrdersInvoicedDetailsResponse[]>
        ).userName ?? "",
    },
    {
      type: DashboardReport.OrdersbyInHandsdate,
      data:
        (
          JSON.parse(
            sessionStorage.getItem(DashboardReport.OrdersbyInHandsdate) ?? "{}"
          ) as DashboardSession<OrderBillingStatus[]>
        ).data ?? {},
      userName:
        (
          JSON.parse(
            sessionStorage.getItem(DashboardReport.OrdersbyInHandsdate) ?? "{}"
          ) as DashboardSession<OrderBillingStatus[]>
        ).userName ?? "",
    },
  ];

  clearAndSetSimpleOrderSearchResponseObj() {
    const orderSearch: string[] = [];
    this._sharedService.setSimpleOrderSearchResponseObject(orderSearch);
  }

  getUnprotectedCustomersCount() {
    this._dashboardService.getUnprotectedCustomersCount().subscribe({
      next: res => {
        if (res) {
          this.expiringDaysCount = res.data;
        }
      },
    });
  }

  getPendingCharges() {
    this._dashboardService.getPendingCharges().subscribe({
      next: res => {
        if (res) {
          this.chargebackCount = res.data;
        }
      },
      error: () => {
        this.chargebackCount = 0;
      },
    });
  }

  getInvoiceProposalsCount() {
    this._dashboardService.getInvoiceProposalsCount().subscribe({
      next: res => {
        if (res) {
          this.invoicePreviewCount = res.data;
        }
      },
      error: () => {
        this.invoicePreviewCount = 0;
      },
    });
  }

  getCDICount() {
    this._dashboardService.getCDICount().subscribe({
      next: res => {
        if (res) {
          this.cdiCount = res.data;
        }
      },
      error: () => {
        this.cdiCount = 0;
      },
    });
  }

  getDisputedInvoiceCount() {
    this._dashboardService.getDisputedInvoicesCount().subscribe({
      next: res => {
        if (res) {
          this.disputedInvoicesCount = res.data;
        }
      },
      error: () => {
        this.invoicePreviewCount = 0;
      },
    });
  }

  // getClientTableData() {
  //   this._dashboardService
  //     .getClientList('Submitted')
  //     .pipe(untilDestroyed(this))
  //     .subscribe((res) => {
  //       this.clientTableData = res.data;
  //       this.filterClientListData = this.clientTableData.map(function (obj) {
  //         return {
  //           Account: obj.customerAccount,
  //           Name: obj.primaryContactName,
  //           AvailableCredit: obj.availableCredit,
  //           Address: obj.clientPrimaryAddress
  //         };
  //       });
  //     });
  // }

  // getVendorTableData() {
  //   this._dashboardService
  //     .getVendorTableRecord()
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: (res: GenericResponseDto<GetAllVendorsDto[]>) => {
  //         const vendorTable =
  //         res.data.length > 7 ? res.data.slice(0, 7) : res.data;
  //         this.filterVendorListData = vendorTable.map(function (obj) {
  //           return {
  //             Account: obj.vendorAccountNumber,
  //             Name: obj.vendorName,
  //             SearchName: obj.vendorSearchName,
  //             Type: obj.vendorType,
  //           };
  //         });
  //         this.vendorTableTata = this.filterVendorListData;
  //       }
  //     });
  // }

  private getReports() {
    this._loaderService.setLoaderState(false);

    this.qr3Response = JSON.parse(sessionStorage.getItem(`qr3Report`) ?? "{}");

    this.getReportsBasedOnUserSettings();
  }

  // modalForq1(status: boolean) {
  //   this.qr1DisplayModal = status;
  // }

  toggleModalForTables(toggleObject: { type: string; status: boolean }) {
    switch (toggleObject.type) {
      case "qr1DisplayModal":
        this.qr1DisplayModal = toggleObject.status;
        break;
      case "qr2DisplayModal":
        this.qr2DisplayModal = toggleObject.status;
        break;
      case "qr3DisplayModal":
        this.qr3DisplayModal = toggleObject.status;
        break;
      case "qr4DisplayModal":
        this.qr4DisplayModal = toggleObject.status;
        break;
      case "qr5DisplayModal":
        this.qr5DisplayModal = toggleObject.status;
        break;
      case "qr6DisplayModal":
        this.qr6DisplayModal = toggleObject.status;
        break;
      default:
        break;
    }
  }

  getReportsBasedOnUserSettings() {
    const token = JSON.parse(localStorage.getItem("user") ?? "");
    const username = token.account.userName ?? "";
    if (this.quadreport1 == DashboardReport.CustomerAging) {
      this.qr1.columns = customerAgingColumns;
      this.qr1.heading = customerAgingheading;
      this.qr1.redirectCompleteLink = customerAgingCompleteListLink;
      this.qr1.displayFooter = false;
      this.qr1.data =
        this.cachedData.find(
          x => x.type == DashboardReport.CustomerAging && x.userName == username
        )?.data ?? [];

      if (this.qr1.data) {
        this.qr1.showSmallLoader = false;
      }

      this.getCustomerAging("qr1");
    } else if (this.quadreport1 == DashboardReport.ReadyToBillReport) {
      this.qr1.columns = readyToBillReportColumns;
      this.qr1.heading = readyToBillReportHeading;
      this.qr1.redirectCompleteLink = this.readyToBillCompleteLinkList;
      this.qr1.displayFooter = false;
      this.qr1.data =
        this.cachedData.find(
          x =>
            x.type == DashboardReport.ReadyToBillReport &&
            x.userName == username
        )?.data ?? [];

      if (this.qr1.data) {
        this.qr1.showSmallLoader = false;
      }

      this.getReadyToBillReport("qr1");
    }

    // Year Over Year Dashboard Report
    else if (this.quadreport1 == DashboardReport.YearOverYearDashboardReport) {
      this.isQr1YearOverYearDashboardReport = true;
      //this.getYearOverYearDashboardReport('qr1');
    } else if (this.quadreport1 == DashboardReport.ArAging) {
      this.qr1.columns = arAgingColumns;
      this.qr1.heading = arAgingheading;
      this.qr1.redirectCompleteLink = arAgingCompleteListLink;
      this.qr1.displayFooter = false;
      this.qr1.data =
        this.cachedData.find(
          x => x.type == DashboardReport.ArAging && x.userName == username
        )?.data ?? [];

      if (this.qr1.data) {
        this.qr1.showSmallLoader = false;
      }

      this.getArAging("qr1");
    } else if (this.quadreport1 == DashboardReport.OrdersWrittenthismonth) {
      this.qr1.columns = ordersWrittenThisMonthColumns;
      this.qr1.heading = ordersWrittenThisMonthHeading;
      this.qr1.redirectCompleteLink = ordersWrittenThisMonthCompleteListLink;
      this.qr1.displayFooter = false;
      this.qr1.data =
        this.cachedData.find(
          x =>
            x.type == DashboardReport.OrdersWrittenthismonth &&
            x.userName == username
        )?.data ?? [];

      if (this.qr1.data) {
        this.qr1.showSmallLoader = false;
      }

      this.getOrdersWrittenthismonth("qr1");
    } else if (this.quadreport1 == DashboardReport.OrdersBilledInvoiced) {
      this.qr1.columns = ordersInvoicedColumns;
      this.qr1.heading = ordersInvoicedHeading;
      this.qr1.redirectCompleteLink = ordersInvoicedCompleteListLink;
      this.qr1.displayFooter = true;

      this.getOrdersBilledInvoiced("qr1");
    } else if (this.quadreport1 == DashboardReport.OrdersbyInHandsdate) {
      this.qr1.columns = openOrdersByInHandsDateColumns;
      this.qr1.heading = openOrdersByInHandsDateHeading;
      this.qr1.redirectCompleteLink = openOrdersByInHandsDateCompleteListLink;
      this.qr1.displayFooter = false;

      this.qr1.data =
        this.cachedData.find(
          x =>
            x.type == DashboardReport.OrdersbyInHandsdate &&
            x.userName == username
        )?.data ?? [];

      if (this.qr1.data) {
        this.qr1.showSmallLoader = false;
      }

      this.getOpenOrdersByInHandsDate("qr1");
    } else {
      this.qr1.showSmallLoader = false;
    }

    if (this.quadreport2 == DashboardReport.CustomerAging) {
      this.qr2.columns = customerAgingColumns;
      this.qr2.heading = customerAgingheading;
      this.qr2.redirectCompleteLink = customerAgingCompleteListLink;
      this.qr2.displayFooter = false;
      this.qr2.data =
        this.cachedData.find(
          x => x.type == DashboardReport.CustomerAging && x.userName == username
        )?.data ?? [];

      if (this.qr2.data) {
        this.qr2.showSmallLoader = false;
      }

      this.getCustomerAging("qr2");
    } else if (this.quadreport2 == DashboardReport.ReadyToBillReport) {
      this.qr2.columns = readyToBillReportColumns;
      this.qr2.heading = readyToBillReportHeading;
      this.qr2.redirectCompleteLink = readyToBillReportCompleteListLink;
      this.qr2.displayFooter = false;

      this.qr2.data =
        this.cachedData.find(
          x =>
            x.type == DashboardReport.ReadyToBillReport &&
            x.userName == username
        )?.data ?? [];

      if (this.qr2.data) {
        this.qr2.showSmallLoader = false;
      }

      this.getReadyToBillReport("qr2");
    }

    // Year Over Year Dashboard Report
    else if (this.quadreport2 == DashboardReport.YearOverYearDashboardReport) {
      this.isQr2YearOverYearDashboardReport = true;
      //this.getYearOverYearDashboardReport('qr2');
    } else if (this.quadreport2 == DashboardReport.ArAging) {
      this.qr2.columns = arAgingColumns;
      this.qr2.heading = arAgingheading;
      this.qr2.redirectCompleteLink = arAgingCompleteListLink;
      this.qr2.displayFooter = false;
      this.qr2.data =
        this.cachedData.find(
          x => x.type == DashboardReport.ArAging && x.userName == username
        )?.data ?? [];

      if (this.qr2.data) {
        this.qr2.showSmallLoader = false;
      }

      this.getArAging("qr2");
    } else if (this.quadreport2 == DashboardReport.OrdersWrittenthismonth) {
      this.qr2.columns = ordersWrittenThisMonthColumns;
      this.qr2.heading = ordersWrittenThisMonthHeading;
      this.qr2.redirectCompleteLink = ordersWrittenThisMonthCompleteListLink;
      this.qr2.displayFooter = false;

      this.qr2.data =
        this.cachedData.find(
          x =>
            x.type == DashboardReport.OrdersWrittenthismonth &&
            x.userName == username
        )?.data ?? [];

      if (this.qr2.data) {
        this.qr2.showSmallLoader = false;
      }

      this.getOrdersWrittenthismonth("qr2");
    } else if (this.quadreport2 == DashboardReport.OrdersBilledInvoiced) {
      this.qr2.columns = ordersInvoicedColumns;
      this.qr2.columns = ordersInvoicedColumns;
      this.qr2.heading = ordersInvoicedHeading;
      this.qr2.redirectCompleteLink = ordersInvoicedCompleteListLink;
      this.qr2.displayFooter = true;

      this.getOrdersBilledInvoiced("qr2");
    } else if (this.quadreport2 == DashboardReport.OrdersbyInHandsdate) {
      this.qr2.columns = openOrdersByInHandsDateColumns;
      this.qr2.heading = openOrdersByInHandsDateHeading;
      this.qr2.redirectCompleteLink = openOrdersByInHandsDateCompleteListLink;
      this.qr2.displayFooter = false;

      this.qr2.data =
        this.cachedData.find(
          x =>
            x.type == DashboardReport.OrdersbyInHandsdate &&
            x.userName == username
        )?.data ?? [];

      if (this.qr2.data) {
        this.qr2.showSmallLoader = false;
      }

      this.getOpenOrdersByInHandsDate("qr2");
    } else {
      this.qr2.showSmallLoader = false;
    }

    if (this.quadreport3 == DashboardReport.CustomerAging) {
      this.qr3.columns = customerAgingColumns;
      this.qr3.heading = customerAgingheading;
      this.qr3.redirectCompleteLink = customerAgingCompleteListLink;
      this.qr3.displayFooter = false;

      this.qr3.data =
        this.cachedData.find(
          x => x.type == DashboardReport.CustomerAging && x.userName == username
        )?.data ?? [];

      if (this.qr3.data) {
        this.qr3.showSmallLoader = false;
      }

      this.getCustomerAging("qr3");
    } else if (this.quadreport3 == DashboardReport.ReadyToBillReport) {
      this.qr3.columns = readyToBillReportColumns;
      this.qr3.heading = readyToBillReportHeading;
      this.qr3.redirectCompleteLink = readyToBillReportCompleteListLink;
      this.qr3.displayFooter = false;

      this.qr3.data =
        this.cachedData.find(
          x =>
            x.type == DashboardReport.ReadyToBillReport &&
            x.userName == username
        )?.data ?? [];

      if (this.qr3.data) {
        this.qr3.showSmallLoader = false;
      }

      this.getReadyToBillReport("qr3");
    }

    // Year Over Year Dashboard Report
    else if (this.quadreport3 == DashboardReport.YearOverYearDashboardReport) {
      this.isQr3YearOverYearDashboardReport = true;
      //this.getYearOverYearDashboardReport('qr2');
    } else if (this.quadreport3 == DashboardReport.ArAging) {
      this.qr3.columns = arAgingColumns;
      this.qr3.heading = arAgingheading;
      this.qr3.redirectCompleteLink = arAgingCompleteListLink;
      this.qr3.displayFooter = false;

      this.qr3.data =
        this.cachedData.find(
          x => x.type == DashboardReport.ArAging && x.userName == username
        )?.data ?? [];

      if (this.qr3.data) {
        this.qr3.showSmallLoader = false;
      }

      this.getArAging("qr3");
    } else if (this.quadreport3 == DashboardReport.OrdersWrittenthismonth) {
      this.qr3.columns = ordersWrittenThisMonthColumns;
      this.qr3.heading = ordersWrittenThisMonthHeading;
      this.qr3.redirectCompleteLink = ordersWrittenThisMonthCompleteListLink;
      this.qr3.displayFooter = false;

      this.qr3.data =
        this.cachedData.find(
          x =>
            x.type == DashboardReport.OrdersWrittenthismonth &&
            x.userName == username
        )?.data ?? [];

      if (this.qr3.data) {
        this.qr3.showSmallLoader = false;
      }

      this.getOrdersWrittenthismonth("qr3");
    } else if (this.quadreport3 == DashboardReport.OrdersBilledInvoiced) {
      this.qr3.columns = ordersInvoicedColumns;
      this.qr3.columns = ordersInvoicedColumns;
      this.qr3.heading = ordersInvoicedHeading;
      this.qr3.redirectCompleteLink = ordersInvoicedCompleteListLink;
      this.qr3.displayFooter = true;

      this.getOrdersBilledInvoiced("qr3");
    } else if (this.quadreport3 == DashboardReport.OrdersbyInHandsdate) {
      this.qr3.columns = openOrdersByInHandsDateColumns;
      this.qr3.heading = openOrdersByInHandsDateHeading;
      this.qr3.redirectCompleteLink = openOrdersByInHandsDateCompleteListLink;
      this.qr3.displayFooter = false;

      this.qr3.data =
        this.cachedData.find(
          x =>
            x.type == DashboardReport.OrdersbyInHandsdate &&
            x.userName == username
        )?.data ?? [];

      if (this.qr3.data) {
        this.qr3.showSmallLoader = false;
      }

      this.getOpenOrdersByInHandsDate("qr3");
    } else {
      this.qr3.showSmallLoader = false;
    }
    if (this.quadreport4 == DashboardReport.CustomerAging) {
      this.qr4.columns = customerAgingColumns;
      this.qr4.heading = customerAgingheading;
      this.qr4.redirectCompleteLink = customerAgingCompleteListLink;
      this.qr4.displayFooter = false;

      this.qr4.data =
        this.cachedData.find(
          x => x.type == DashboardReport.CustomerAging && x.userName == username
        )?.data ?? [];

      if (this.qr4.data) {
        this.qr4.showSmallLoader = false;
      }

      this.getCustomerAging("qr4");
    } else if (this.quadreport4 == DashboardReport.ReadyToBillReport) {
      this.qr4.columns = readyToBillReportColumns;
      this.qr4.heading = readyToBillReportHeading;
      this.qr4.redirectCompleteLink = readyToBillReportCompleteListLink;
      this.qr4.displayFooter = false;

      this.qr4.data =
        this.cachedData.find(
          x =>
            x.type == DashboardReport.ReadyToBillReport &&
            x.userName == username
        )?.data ?? [];

      if (this.qr4.data) {
        this.qr4.showSmallLoader = false;
      }

      this.getReadyToBillReport("qr4");
    }

    // Year Over Year Dashboard Report
    else if (this.quadreport4 == DashboardReport.YearOverYearDashboardReport) {
      this.isQr4YearOverYearDashboardReport = true;
      //this.getYearOverYearDashboardReport('qr2');
    } else if (this.quadreport4 == DashboardReport.ArAging) {
      this.qr4.columns = arAgingColumns;
      this.qr4.heading = arAgingheading;
      this.qr4.redirectCompleteLink = arAgingCompleteListLink;
      this.qr4.displayFooter = false;

      this.qr4.data =
        this.cachedData.find(
          x => x.type == DashboardReport.ArAging && x.userName == username
        )?.data ?? [];

      if (this.qr4.data) {
        this.qr4.showSmallLoader = false;
      }

      this.getArAging("qr4");
    } else if (this.quadreport4 == DashboardReport.OrdersWrittenthismonth) {
      this.qr4.columns = ordersWrittenThisMonthColumns;
      this.qr4.heading = ordersWrittenThisMonthHeading;
      this.qr4.redirectCompleteLink = ordersWrittenThisMonthCompleteListLink;
      this.qr4.displayFooter = false;

      this.qr4.data =
        this.cachedData.find(
          x =>
            x.type == DashboardReport.OrdersWrittenthismonth &&
            x.userName == username
        )?.data ?? [];

      if (this.qr4.data) {
        this.qr4.showSmallLoader = false;
      }

      this.getOrdersWrittenthismonth("qr4");
    } else if (this.quadreport4 == DashboardReport.OrdersBilledInvoiced) {
      this.qr4.columns = ordersInvoicedColumns;
      this.qr4.heading = ordersInvoicedHeading;
      this.qr4.redirectCompleteLink = ordersInvoicedCompleteListLink;
      this.qr4.displayFooter = true;
      this.getOrdersBilledInvoiced("qr4");
    } else if (this.quadreport4 == DashboardReport.OrdersbyInHandsdate) {
      this.qr4.columns = openOrdersByInHandsDateColumns;
      this.qr4.heading = openOrdersByInHandsDateHeading;
      this.qr4.redirectCompleteLink = openOrdersByInHandsDateCompleteListLink;
      this.qr4.displayFooter = false;

      this.qr4.data =
        this.cachedData.find(
          x =>
            x.type == DashboardReport.OrdersbyInHandsdate &&
            x.userName == username
        )?.data ?? [];

      if (this.qr4.data) {
        this.qr4.showSmallLoader = false;
      }

      this.getOpenOrdersByInHandsDate("qr4");
    } else {
      this.qr4.showSmallLoader = false;
    }
  }

  getCustomerAging(reportType: string) {
    this._dashboardService
      .getCustomerAging()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<QR1ReportsDto[]>) => {
          const token = JSON.parse(localStorage.getItem("user") ?? "");
          const username = token.account.userName ?? "";
          const session: DashboardSession<QR1ReportsDto[]> = {
            data: res.data,
            type: DashboardReport.CustomerAging,
            userName: username,
          };
          sessionStorage.setItem(
            DashboardReport.CustomerAging,
            JSON.stringify(session)
          );

          if (reportType == "qr1") {
            this.qr1ReportsSmallLoader = false;
            this.qr1 = {
              columns: this.customerAgingColumns,
              data: res.data,
              heading: this.customerAgingheading,
              redirectCompleteLink: this.customerAgingCompleteListLink,
              showSmallLoader: this.qr1ReportsSmallLoader,
              displayFooter: false,
            };
          } else if (reportType == "qr2") {
            this.qr2ReportsSmallLoader = false;

            this.qr2 = {
              columns: this.customerAgingColumns,
              data: res.data,
              heading: this.customerAgingheading,
              redirectCompleteLink: this.customerAgingCompleteListLink,
              showSmallLoader: this.qr2ReportsSmallLoader,
              displayFooter: false,
            };
          } else if (reportType == "qr3") {
            this.qr3ReportsSmallLoader = false;

            this.qr3 = {
              columns: this.customerAgingColumns,
              data: res.data,
              heading: this.customerAgingheading,
              redirectCompleteLink: this.customerAgingCompleteListLink,
              showSmallLoader: this.qr3ReportsSmallLoader,
              displayFooter: false,
            };
          } else if (reportType == "qr4") {
            this.qr4ReportsSmallLoader = false;

            this.qr4 = {
              columns: this.customerAgingColumns,
              data: res.data,
              heading: this.customerAgingheading,
              redirectCompleteLink: this.customerAgingCompleteListLink,
              showSmallLoader: this.qr4ReportsSmallLoader,
              displayFooter: false,
            };
          }
        },
        error: () => {
          this.qr1ReportsSmallLoader = false;
          this.qr2ReportsSmallLoader = false;
          this.qr3ReportsSmallLoader = false;
          this.qr4ReportsSmallLoader = false;
        },
      });
  }

  getArAging(reportType: string) {
    this._dashboardService
      .getArAgingDetailReport()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<CustomerAgingDetailReport[]>) => {
          const token = JSON.parse(localStorage.getItem("user") ?? "");
          const username = token.account.username ?? "";
          const session: DashboardSession<CustomerAgingDetailReport[]> = {
            data: res.data,
            type: DashboardReport.ArAging,
            userName: username,
          };
          sessionStorage.setItem(
            DashboardReport.ArAging,
            JSON.stringify(session)
          );

          if (reportType == "qr1") {
            this.qr1ReportsSmallLoader = false;
            this.qr1 = {
              columns: this.arAgingColumns,
              data: res.data,
              heading: this.arAgingheading,
              redirectCompleteLink: this.arAgingCompleteListLink,
              showSmallLoader: this.qr1ReportsSmallLoader,
              displayFooter: false,
            };
          } else if (reportType == "qr2") {
            this.qr2ReportsSmallLoader = false;

            this.qr2 = {
              columns: this.arAgingColumns,
              data: res.data,
              heading: this.arAgingheading,
              redirectCompleteLink: this.arAgingCompleteListLink,
              showSmallLoader: this.qr2ReportsSmallLoader,
              displayFooter: false,
            };
          } else if (reportType == "qr3") {
            this.qr3ReportsSmallLoader = false;

            this.qr3 = {
              columns: this.arAgingColumns,
              data: res.data,
              heading: this.arAgingheading,
              redirectCompleteLink: this.arAgingCompleteListLink,
              showSmallLoader: this.qr3ReportsSmallLoader,
              displayFooter: false,
            };
          } else if (reportType == "qr4") {
            this.qr4ReportsSmallLoader = false;

            this.qr4 = {
              columns: this.arAgingColumns,
              data: res.data,
              heading: this.arAgingheading,
              redirectCompleteLink: this.arAgingCompleteListLink,
              showSmallLoader: this.qr4ReportsSmallLoader,
              displayFooter: false,
            };
          }
        },
        error: () => {
          this.qr1ReportsSmallLoader = false;
          this.qr2ReportsSmallLoader = false;
          this.qr3ReportsSmallLoader = false;
          this.qr4ReportsSmallLoader = false;
        },
      });
  }

  getOrdersWrittenthismonth(reportType: string) {
    this._dashboardService
      .getOrdersWrittenthismonth()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<QR2Reports>) => {
          if (res?.data) {
            this.qR2Reports = res.data;
            if (this.qR2Reports?.qR2ReportsDtos) {
              this.qr2List = this.qR2Reports.qR2ReportsDtos;
            }
          }
          const token = JSON.parse(localStorage.getItem("user") ?? "");
          const username = token.account.username ?? "";
          const session: DashboardSession<QR2Reports> = {
            data: res.data,
            type: DashboardReport.OrdersWrittenthismonth,
            userName: username,
          };
          sessionStorage.setItem(
            DashboardReport.OrdersWrittenthismonth,
            JSON.stringify(session)
          );

          if (reportType == "qr1") {
            this.qr1ReportsSmallLoader = false;

            this.qr1 = {
              columns: this.ordersWrittenThisMonthColumns,
              data: this.qr2List,
              heading: this.ordersWrittenThisMonthHeading,
              redirectCompleteLink: this.ordersWrittenThisMonthCompleteListLink,
              showSmallLoader: this.qr1ReportsSmallLoader,
              displayFooter: true,
            };
          } else if (reportType == "qr2") {
            this.qr2ReportsSmallLoader = false;

            this.qr2 = {
              columns: this.ordersWrittenThisMonthColumns,
              data: this.qr2List,
              heading: this.ordersWrittenThisMonthHeading,
              redirectCompleteLink: this.ordersWrittenThisMonthCompleteListLink,
              showSmallLoader: this.qr2ReportsSmallLoader,
              displayFooter: false,
            };
          } else if (reportType == "qr3") {
            this.qr3ReportsSmallLoader = false;

            this.qr3 = {
              columns: this.ordersWrittenThisMonthColumns,
              data: this.qr2List,
              heading: this.ordersWrittenThisMonthHeading,
              redirectCompleteLink: this.ordersWrittenThisMonthCompleteListLink,
              showSmallLoader: this.qr3ReportsSmallLoader,
              displayFooter: false,
            };
          } else if (reportType == "qr4") {
            this.qr4ReportsSmallLoader = false;

            this.qr4 = {
              columns: this.ordersWrittenThisMonthColumns,
              data: this.qr2List,
              heading: this.ordersWrittenThisMonthHeading,
              redirectCompleteLink: this.ordersWrittenThisMonthCompleteListLink,
              showSmallLoader: this.qr4ReportsSmallLoader,
              displayFooter: false,
            };
          }
        },
        error: () => {
          this.qr1ReportsSmallLoader = false;
          this.qr2ReportsSmallLoader = false;
          this.qr3ReportsSmallLoader = false;
          this.qr4ReportsSmallLoader = false;
        },
      });
  }

  getReadyToBillReport(reportType: string) {
    this._dashboardService
      .getReadyToBillReport()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<ReadyToBillDto[]>) => {
          const token = JSON.parse(localStorage.getItem("user") ?? "");
          const username = token.account.username ?? "";
          const session: DashboardSession<ReadyToBillDto[]> = {
            data: res.data,
            type: DashboardReport.ReadyToBillReport,
            userName: username,
          };
          sessionStorage.setItem(
            DashboardReport.ReadyToBillReport,
            JSON.stringify(session)
          );

          if (reportType == "qr1") {
            this.qr1ReportsSmallLoader = false;
            this.qr1 = {
              columns: this.readyToBillReportColumns,
              data: res.data,
              heading: this.readyToBillReportHeading,
              redirectCompleteLink: this.readyToBillCompleteLinkList,
              showSmallLoader: this.qr1ReportsSmallLoader,
              displayFooter: false,
            };
          } else if (reportType == "qr2") {
            this.qr2ReportsSmallLoader = false;

            this.qr2 = {
              columns: this.readyToBillReportColumns,
              data: res.data,
              heading: this.readyToBillReportHeading,
              redirectCompleteLink: this.readyToBillCompleteLinkList,
              showSmallLoader: this.qr2ReportsSmallLoader,
              displayFooter: false,
            };
          } else if (reportType == "qr3") {
            this.qr3ReportsSmallLoader = false;

            this.qr3 = {
              columns: this.readyToBillReportColumns,
              data: res.data,
              heading: this.readyToBillReportHeading,
              redirectCompleteLink: this.readyToBillCompleteLinkList,
              showSmallLoader: this.qr3ReportsSmallLoader,
              displayFooter: false,
            };
          } else if (reportType == "qr4") {
            this.qr4ReportsSmallLoader = false;

            this.qr4 = {
              columns: this.readyToBillReportColumns,
              data: res.data,
              heading: this.readyToBillReportHeading,
              redirectCompleteLink: this.readyToBillCompleteLinkList,
              showSmallLoader: this.qr4ReportsSmallLoader,
              displayFooter: false,
            };
          }
        },
        error: () => {
          this.qr1ReportsSmallLoader = false;
          this.qr2ReportsSmallLoader = false;
          this.qr3ReportsSmallLoader = false;
          this.qr4ReportsSmallLoader = false;
        },
      });
  }

  getOpenOrdersByInHandsDate(reportType: string) {
    this._dashboardService
      .getOpenOrdersByInHandsDate()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<OrderBillingStatus[]>) => {
          const token = JSON.parse(localStorage.getItem("user") ?? "");
          const username = token.account.username ?? "";
          const session: DashboardSession<OrderBillingStatus[]> = {
            data: res.data,
            type: DashboardReport.OrdersbyInHandsdate,
            userName: username,
          };
          sessionStorage.setItem(
            DashboardReport.OrdersbyInHandsdate,
            JSON.stringify(session)
          );

          if (reportType == "qr1") {
            this.qr1ReportsSmallLoader = false;

            this.qr1 = {
              columns: this.openOrdersByInHandsDateColumns,
              data: res.data,
              heading: this.openOrdersByInHandsDateHeading,
              redirectCompleteLink:
                this.openOrdersByInHandsDateCompleteListLink,
              showSmallLoader: this.qr1ReportsSmallLoader,
              displayFooter: false,
            };
          } else if (reportType == "qr2") {
            this.qr2ReportsSmallLoader = false;

            this.qr2 = {
              columns: this.openOrdersByInHandsDateColumns,
              data: res.data,
              heading: this.openOrdersByInHandsDateHeading,
              redirectCompleteLink:
                this.openOrdersByInHandsDateCompleteListLink,
              showSmallLoader: this.qr2ReportsSmallLoader,
              displayFooter: false,
            };
          } else if (reportType == "qr3") {
            this.qr3ReportsSmallLoader = false;

            this.qr3 = {
              columns: this.openOrdersByInHandsDateColumns,
              data: res.data,
              heading: this.openOrdersByInHandsDateHeading,
              redirectCompleteLink:
                this.openOrdersByInHandsDateCompleteListLink,
              showSmallLoader: this.qr3ReportsSmallLoader,
              displayFooter: false,
            };
          } else if (reportType == "qr4") {
            this.qr4ReportsSmallLoader = false;

            this.qr4 = {
              columns: this.openOrdersByInHandsDateColumns,
              data: res.data,
              heading: this.openOrdersByInHandsDateHeading,
              redirectCompleteLink:
                this.openOrdersByInHandsDateCompleteListLink,
              showSmallLoader: this.qr4ReportsSmallLoader,
              displayFooter: false,
            };
          }
        },
        error: () => {
          this.qr1ReportsSmallLoader = false;
          this.qr2ReportsSmallLoader = false;
          this.qr3ReportsSmallLoader = false;
          this.qr4ReportsSmallLoader = false;
        },
      });
  }

  getOrdersBilledInvoiced(reportType: string) {
    this._dashboardService
      .getOrdersBilledInvoiced()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<QR3ReportsResponse>) => {
          const token = JSON.parse(localStorage.getItem("user") ?? "");
          const username = token.account.username ?? "";
          const session: DashboardSession<QR3ReportsResponse> = {
            data: res.data,
            type: DashboardReport.OrdersBilledInvoiced,
            userName: username,
          };
          sessionStorage.setItem(
            DashboardReport.OrdersBilledInvoiced,
            JSON.stringify(session)
          );

          if (reportType == "qr1") {
            this.qr1ReportsSmallLoader = false;
            this.qr3Response = res.data ?? {};

            this.qr1 = {
              columns: this.ordersInvoicedColumns,
              data: res.data?.qR3ReportsDto ?? [],
              heading: this.ordersInvoicedHeading,
              redirectCompleteLink: this.ordersInvoicedCompleteListLink,
              showSmallLoader: this.qr1ReportsSmallLoader,
              displayFooter: true,
              freightTotal: res.data?.freightTotal ?? 0,
              invTotalSum: res.data?.invTotalSum ?? 0,
              merchTotal: res.data?.merchTotal ?? 0,
              taxTotal: res.data?.taxTotal ?? 0,
            };
          } else if (reportType == "qr2") {
            this.qr2ReportsSmallLoader = false;
            this.qr3Response = res.data ?? {};

            this.qr2 = {
              columns: this.ordersInvoicedColumns,
              data: res.data?.qR3ReportsDto ?? [],
              heading: this.ordersInvoicedHeading,
              redirectCompleteLink: this.ordersInvoicedCompleteListLink,
              showSmallLoader: this.qr2ReportsSmallLoader,
              displayFooter: true,
              freightTotal: res.data?.freightTotal ?? 0,
              invTotalSum: res.data?.invTotalSum ?? 0,
              merchTotal: res.data?.merchTotal ?? 0,
              taxTotal: res.data?.taxTotal ?? 0,
            };
          } else if (reportType == "qr3") {
            this.qr3ReportsSmallLoader = false;
            this.qr3Response = res.data ?? {};

            this.qr3 = {
              columns: this.ordersInvoicedColumns,
              data: res.data?.qR3ReportsDto ?? [],
              heading: this.ordersInvoicedHeading,
              redirectCompleteLink: this.ordersInvoicedCompleteListLink,
              showSmallLoader: this.qr3ReportsSmallLoader,
              displayFooter: true,
              freightTotal: res.data?.freightTotal ?? 0,
              invTotalSum: res.data?.invTotalSum ?? 0,
              merchTotal: res.data?.merchTotal ?? 0,
              taxTotal: res.data?.taxTotal ?? 0,
            };
          } else if (reportType == "qr4") {
            this.qr4ReportsSmallLoader = false;
            this.qr3Response = res.data ?? {};
            this.qr4 = {
              columns: this.ordersInvoicedColumns,
              data: res.data?.qR3ReportsDto ?? [],
              heading: this.ordersInvoicedHeading,
              redirectCompleteLink: this.ordersInvoicedCompleteListLink,
              showSmallLoader: this.qr4ReportsSmallLoader,
              displayFooter: true,
              freightTotal: res.data?.freightTotal ?? 0,
              invTotalSum: res.data?.invTotalSum ?? 0,
              merchTotal: res.data?.merchTotal ?? 0,
              taxTotal: res.data?.taxTotal ?? 0,
            };
          }
        },
        error: () => {
          this.qr1ReportsSmallLoader = false;
          this.qr2ReportsSmallLoader = false;
          this.qr3ReportsSmallLoader = false;
          this.qr4ReportsSmallLoader = false;
        },
      });
  }

  getUserSetting() {
    this._loaderService.setLoaderState(true);
    this._dashboardService.GetUserSettings().subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.data) {
          const dashboardSetting: DashboardSetting = JSON.parse(
            res.data.dashboardReports
          );
          if (dashboardSetting.qr1) {
            this.quadreport1 = dashboardSetting.qr1;
          }
          if (dashboardSetting.qr2) {
            this.quadreport2 = dashboardSetting.qr2;
          }
          if (dashboardSetting.qr3) {
            this.quadreport3 = dashboardSetting.qr3;
          }
          if (dashboardSetting.qr4) {
            this.quadreport4 = dashboardSetting.qr4;
          }
          this.getReports();
        } else {
          this._toastr.error(
            "Dashboard Settings Not Found. Enable Settings From Profile",
            "Settings Not Found"
          );
          this.qr1.showSmallLoader = false;
          this.qr2.showSmallLoader = false;
          this.qr3.showSmallLoader = false;
          this.qr4.showSmallLoader = false;
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  getJNIDeletedRecordsQueueTrigger() {
    this._dashboardService.getJNIDeletedRecordsQueueTrigger().subscribe();
  }

  public get DashboardReport(): typeof DashboardReport {
    return DashboardReport;
  }

  getArAgingFullData() {
    this._dashboardService
      .getArAgingDetailReport(0)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<CustomerAgingDetailReport[]>) => {
          if (res?.data) {
            if (res?.data.length > 0) {
              this.totalOutstanding = res?.data.reduce(
                (total, charge) => total + charge.openAmountUSD,
                0
              );
            }
          }
        },
        error: () => {
          // TODO logs error here
        },
      });
  }

  scrollHiddenStatus() {
    setTimeout(() => {
      this.renderer.removeClass(document.body, "p-overflow-hidden");
    }, 0);
  }

  closeModalForSaleOrder() {
    this.orderDisplayModal = false;
  }

  closeModalForClient() {
    this.clientDisplayModal = false;
  }

  closeModalForSamplePO() {
    this.samplePODisplayModal = false;
  }

  showModuleModal(obj: { moduleName: string; value: string }) {
    if (obj.moduleName === "order") {
      this.saleOrderId = obj.value;
      this.orderDisplayModal = true;
    } else if (obj.moduleName === "client") {
      this.clientId = obj.value;
      this.clientDisplayModal = true;
    } else if (obj.moduleName === "samplePO") {
      this.clientId = obj.value;
      this.clientDisplayModal = true;
    }
  }
}
